import React, { useEffect, useState } from 'react';
import { DataTableColumn } from '@common/components/datatable/types';
import Badge from '@common/components/badge';
import { useTranslation } from 'react-i18next';
import { FormsData } from '@modules/performance/types';
import { FormIcon } from '@modules/forms/components/form-icon';
import moment from 'moment';
import { FormActions } from '@modules/performance/components/form-actions/form-actions';
import { useHistory, useParams } from 'react-router';
import { useEncodedFullPath } from '@common/hooks/url';
import { EPerformanceFormStatus, EvaluationFormTypes } from '@common/definitions';
import { SimpleUser } from '@common/types/objects';
import LinkWrapper from '@common/components/linkWrapper';
import Profile from '@common/components/profile';


export default (data: FormsData[], columnOptions: any) => {
  const history = useHistory();
  const params = useParams<{ networkId: string }>();
  const basePath = params.networkId ? `/networks/${params.networkId}` : '/admin';
  const encodedPath = useEncodedFullPath();
  const { t } = useTranslation();
  const [columns, setColumns] = useState<DataTableColumn[]>([]);

  const { handleDeleteForm, handleArchiveForm, handleUnarchiveForm } =
    columnOptions;

     const EvaluationFormTypesMap = {
      manager: {
        label: t('performance:manager'),
      },
      manager_employee: {
        label: t('performance:manager_employee'),
      },
    };


  useEffect(() => {
    const baseColumns: DataTableColumn[] = [
      {
        key: 'title',
        label: t('performance:name'),
        options: {
          render: (row: FormsData) => (
            <div className="tw-items-center tw-gap-3 tw-py-1 tw-w-full FormTitle">
              <FormIcon form={row} />
              <a
                className="tw-font-medium tw-text-gray-textDarkest tw-text-base tw-font-inter"
                onClick={() => {
                  const base = `${basePath}/performance/forms/${row.id}/edit`;
                  return history.push(`${base}/components?back=${encodedPath}`);
                }}
                role="button"
              >
                {row.title}
              </a>
            </div>
          ),
        },
      },
      {
        key: 'type',
        label: t('performance:type'),
        options: {
          renderLite: (value: string) => (
            <div className="tw-flex tw-justify-center">
              <Badge text={EvaluationFormTypesMap[value as EvaluationFormTypes].label} />
            </div>
          ),
        },
      },
      {
        key: 'status',
        label: t('performance:status'),
        options: {
          renderLite: (value: string) => <Badge status={value as EPerformanceFormStatus} />,
        },
      },
      {
        key: 'created_by',
        label: t('performance:created_by'),
        className: 'tw-font-semibold',
        options: {
          renderLite: (user: SimpleUser) => {
            return (
              <LinkWrapper
                url={`${basePath}/users/${user.id}/about`}
                className="tw-text-inherit hover:tw-text-inherit hover:tw-underline"
              >
                <Profile enablePopover size={30} user={user} />
              </LinkWrapper>
            );
          },
        },
      },
      {
        key: 'created_at',
        label: t('performance:created_at'),
        options: {
          renderLite: (value: string) => (
            <div className="tw-flex tw-justify-center">
              <span className="tw-text-base tw-text-gray-text tw-font-medium tw-font-inter">
                {moment(value).format('MMM D, YYYY')}
              </span>
            </div>
          ),
        },
      },
      {
        key: 'actions',
        label: '',
        className: 'Table__Action',
        options: {
          size: 20,
          render: (row: FormsData) => {
            return (
              <FormActions
                item={row}
                onArchive={() => handleArchiveForm(row)}
                onDelete={() => handleDeleteForm(row)}
                onUnarchive={() => handleUnarchiveForm(row)}
              />
            );
          },
        },
      },
    ];

    setColumns(baseColumns);
  }, [t, data]);

  return columns;
};
